'use strict';

/**
 *
 * @name: shareStickyFooter
 *
 */

import DirectiveTemplate from './nn-share-sticky-footer.directive.html';

function ShareStickyFooterDirective($rootScope, $timeout, playersAnalytics, campaignTrackingServ) {

  'ngInject';

  return {
    restrict: 'E',
    replace: true,
    template: DirectiveTemplate,
    scope: {
      lang: '=',
      post: '=',
      settings: '='
    },
    link: function (scope, element) {

      var rootWatchers = {};

      scope.emailSubject = 'NOWNESS ' + encodeURIComponent(scope.post.translations[scope.lang].title);
      scope.emailBody = generateEmailShareLink();
      scope.whatappShareLink = generateWhatsAppShareLink();

      $timeout(function () {
        // create whatsapp button with delay
        // to get time to generate dynamic url
        WASHAREBTN.crBtn();
      }, 500);

      scope.playersAnalytics = playersAnalytics;

      rootWatchers.bWidth = $rootScope.$watch('bWidth', function () {

        updateShareOptionsPosition();
      });

      rootWatchers.showPersistentVideo = $rootScope.$watch('showPersistentVideo', function () {

        updateShareOptionsPosition();
      });

      document.addEventListener('playerLoad', function () {

        updateShareOptionsPosition();
      });

      document.addEventListener('imgLoaded', function () {

        updateShareOptionsPosition();
      });

      updateShareOptionsPosition();

      /* private */

      function generateWhatsAppShareLink() {

        var url = location.protocol + '//' + location.host + '/story/' + scope.post.translations[scope.lang].slug;
        url += '?' + campaignTrackingServ.generateTrackingParams('whatsapp', 'mobile', 'share');

        return url;
      }

      function generateEmailShareLink() {

        var url = encodeURIComponent(scope.post.translations[scope.lang].subtitle) + '%0D%0A' + encodeURIComponent(location.protocol + '//' + location.host + '/story/' + scope.post.translations[scope.lang].slug);
        url += '?' + encodeURIComponent(campaignTrackingServ.generateTrackingParams('email', 'mobile', 'share'));

        return url;
      }

      function updateShareOptionsPosition() {

        var contentWrapper;
        var posTop = element.offset().top;
        var articleWrapper = element.closest('div[role="main"]').find('.single-article .article-content');
        var isArticle = articleWrapper.length;

        if (isArticle) {

          contentWrapper = articleWrapper;
        } else {

          contentWrapper = $('.single-video-wrapper');
        }

        $(window).off('scroll.shareStickyFooter');
        $(window).on('scroll.shareStickyFooter', function () {

          if (contentWrapper.length) {

            element.toggleClass('hidden', posTop + element.height() > contentWrapper.offset().top + contentWrapper.outerHeight() - window.scrollY);
          }
        });

        scope.$on('$destroy', function () {

          Object.keys(rootWatchers)
            .forEach(function (killWatcherKey) {

              rootWatchers[killWatcherKey]();
            });
          $(window).off('scroll.shareStickyFooter');
          element.find('*').remove();
          articleWrapper = null;
          isArticle = null;
          contentWrapper = null;
          posTop = null;
        });
      }
    }
  };
}

export default ShareStickyFooterDirective;



// WEBPACK FOOTER //
// ./app/components/nn-players/nn-share-sticky-footer/nn-share-sticky-footer.directive.js